import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadUserTariffs,
  LocalizePropType,
  selectTariffs,
  selectUser,
  updateUser,
  withTextLocalizer,
  getNextUserOpenChallengeRoute,
  isCTF,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import UpsellingsView from './UpsellingsView';
import { isStaging, navigateTo } from '../../../../utils';

interface Values {}

type Props = {
  localize: LocalizePropType;
};

const UpsellingsContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const tariffs = useSelector(selectTariffs);
  const selectedUser = useSelector(selectUser);
  const [upsellingSelected, setUpsellingSelected] = useState(
    selectedUser?.tariff?.upsellings?.[0]?.code || 'free'
  );
  const selectedTariffUpsellings = tariffs?.find(
    (tariff) => tariff?.id === selectedUser?.tariff?.id || tariffs?.[0]?.id
  )?.upsellings;
  const upsellings = [...(selectedTariffUpsellings || []), { code: 'free' }];
  const isBusiness =
    selectedUser?.userType === 'org' ||
    selectedUser?.address?.billingProfile === 'business';

  const [showUpsellingDialog, setShowUpsellingDialog] = useState(false);

  const isUpsellingDialogEnabled = () =>
    process.env.VITE_UPSELLING_DIALOG_ENABLED === 'true';

  const onSuccess = (user = selectedUser) => {
    navigateTo(history, getNextUserOpenChallengeRoute(user));
  };

  const onSubmitAction = () => {
    dispatch(
      // @ts-ignore
      updateUser(
        {
          tariff: {
            // ...(isCTF() && { id: tariffs?.[0]?.id }),
            upsellings:
              upsellingSelected === 'free'
                ? []
                : [
                    {
                      code: upsellingSelected,
                    },
                  ],
          },
        },
        (user) => {
          onSuccess(user);
        }
      )
    );
  };

  const onSubmit = () => {
    if (upsellingSelected === 'free' && isUpsellingDialogEnabled()) {
      setShowUpsellingDialog(true);
    } else {
      onSubmitAction();
    }
  };

  const onClose = () => {
    history.goBack();
  };

  useEffect(() => {
    dispatch(loadUserTariffs());
  }, []);

  const handleYesAction = () => {
    setUpsellingSelected(upsellings[0]?.code);
    setShowUpsellingDialog(false);
  };

  const handleNoAction = () => {
    onSubmitAction();
    setShowUpsellingDialog(false);
  };

  return (
    <UpsellingsView
      localize={localize}
      upsellings={upsellings}
      isBusiness={isBusiness}
      onClose={onClose}
      onSubmit={onSubmit}
      upsellingSelected={upsellingSelected}
      setUpsellingSelected={setUpsellingSelected}
      showUpsellingDialog={showUpsellingDialog}
      handleYesAction={handleYesAction}
      handleNoAction={handleNoAction}
      isUpsellingDialogEnabled={isUpsellingDialogEnabled}
    />
  );
};

export default withTextLocalizer(UpsellingsContainer);
